export const metaPublic = {
  layout: 'LayoutPublic'
}
export const metaAccount = {
  layout: 'LayoutDefault',
  auth: true,
  context: 'global'
}
